// All user-facing strings. Kept flat (dot-notation) so the lookup stays cheap
// and searches in the codebase show where each key is used.
const translations = {
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.garage": "Garage",
    "nav.request": "Request",
    "nav.contact": "Contact",
    "nav.cta": "Request a Car",
    "nav.language.en": "EN",
    "nav.language.gr": "GR",

    // Hero
    "hero.headline": "Find the right car. Without compromise.",
    "hero.subheadline":
      "We source and deliver premium vehicles tailored to your exact needs.",
    "hero.tagline": "Private Selection · By Appointment",
    "hero.cta.primary": "View Available Cars",
    "hero.cta.secondary": "Request a Car",

    // The House
    "house.label": "The House",
    "house.title.part1": "A quiet home for",
    "house.title.accent": "exceptional automobiles",
    "house.p1":
      "Elysian Cars is a boutique dealership under THS Estate Development Group E.E. — a small, carefully assembled selection of automobiles sourced and prepared for a discerning clientele.",
    "house.p2":
      "We do not operate as a marketplace. Each vehicle is the result of a private search, a considered selection, and a focused approach.",
    "house.p3": "Access is by appointment only.",

    // A Different Approach
    "approach.label": "A Different Approach",
    "approach.title.part1": "No showroom noise.",
    "approach.title.accent": "Just the right car.",
    "approach.body":
      "We source globally, inspect privately, and present only what meets our standards. No pressure, no excess — only carefully selected vehicles.",
    "approach.stat.sourced": "Sourced",
    "approach.stat.sourced.v": "Worldwide",
    "approach.stat.process": "Process",
    "approach.stat.process.v": "Private",
    "approach.stat.selection": "Selection",
    "approach.stat.selection.v": "Curated",
    "approach.stat.delivery": "Delivery",
    "approach.stat.delivery.v": "By Appointment",

    // Featured
    "featured.label": "Featured",
    "featured.title": "In the garage",
    "featured.viewAll": "View all",

    // CTA block
    "cta.label": "Custom Request",
    "cta.title.part1": "Can't find it?",
    "cta.title.accent": "We'll source it.",
    "cta.body":
      "Tell us what you are looking for — a specific model, specification, colour, or chassis. We'll quietly search our network and come back to you.",
    "cta.button": "Request a Car",

    // Garage
    "garage.label": "The Garage",
    "garage.title": "Available now",
    "garage.subtitle":
      "A small, rotating selection. Every car inspected, prepared and ready for a private appointment.",
    "garage.filter.all": "All",
    "garage.filter.available": "Available",
    "garage.filter.reserved": "Reserved",
    "garage.filter.sold": "Sold",
    "garage.empty.title": "No vehicles in this category.",
    "garage.empty.subtitle": "Check back soon or submit a private request.",

    // Vehicle card / detail
    "vehicle.status.available": "Available",
    "vehicle.status.reserved": "Reserved",
    "vehicle.status.sold": "Sold",
    "vehicle.spec.year": "Year",
    "vehicle.spec.km": "Km",
    "vehicle.spec.mileage": "Mileage",
    "vehicle.spec.fuel": "Fuel",
    "vehicle.spec.transmission": "Transmission",
    "vehicle.spec.transmission.short": "Trans.",
    "vehicle.price": "Price",
    "vehicle.back": "Back to Garage",
    "vehicle.notFound": "Vehicle not found",
    "vehicle.loading": "Loading…",
    "vehicle.enquire": "Enquire About This Car",
    "vehicle.bookAppointment": "Book Appointment",

    // Request form
    "request.label": "Request a Car",
    "request.title.part1": "Describe what you are",
    "request.title.accent": "looking for",
    "request.intro":
      "We source selected vehicles based on your specifications and standards.",
    "request.note": "Selected vehicles. By appointment only.",
    "request.channels.whatsapp": "WhatsApp",
    "request.channels.viber": "Viber",
    "request.channels.phone": "Phone",
    "request.channels.email": "Email",
    "request.contact.phone": "Phone",
    "request.contact.email": "Email",
    "request.form.name": "Name",
    "request.form.name.placeholder": "Your name",
    "request.form.phone": "Phone",
    "request.form.phone.placeholder": "+30 ...",
    "request.form.email": "Email",
    "request.form.email.placeholder": "you@example.com",
    "request.form.preference": "What are you looking for",
    "request.form.preference.placeholder":
      "Model, specification, year, colour, options…",
    "request.form.budget": "Budget",
    "request.form.budget.placeholder": "€ range",
    "request.form.message": "Message",
    "request.form.message.placeholder":
      "Specifications, timeline, any additional notes...",
    "request.form.submit": "Send Request",
    "request.form.submitting": "Sending…",
    "request.success.title": "Request received",
    "request.success.subtitle":
      "Our team will contact you shortly to discuss your request.",
    "request.success.again": "Submit another request",
    "request.toast.success": "Request received. We'll be in touch.",
    "request.toast.error": "Something went wrong",

    // Contact
    "contact.label": "Contact",
    "contact.title.part1": "Come find us —",
    "contact.title.accent": "privately",
    "contact.intro":
      "We operate by appointment only. Reach us directly on the channels below or request a specific car through our form — we'll respond within one business day.",
    "contact.cell.phone": "Phone",
    "contact.cell.email": "Email",
    "contact.cell.whatsapp": "WhatsApp",
    "contact.cell.whatsapp.v": "Chat with us",
    "contact.cell.viber": "Viber",
    "contact.cell.viber.v": "Open in Viber",
    "contact.cell.hours": "Hours",
    "contact.cell.hours.v": "By Appointment",
    "contact.side.label": "Looking for a specific car?",
    "contact.side.title": "Open a private request.",
    "contact.side.body":
      "If you have a shortlist — or a single car in mind — tell us exactly what you want. We will come back to you with options, quietly.",
    "contact.side.cta": "Request a Car",

    // Footer
    "footer.company": "THS Estate Development Group E.E.",
    "footer.rights": "— All rights reserved",
    "footer.signature": "Private Selection · By Appointment",

    // WhatsApp / Viber
    "whatsapp.label": "WhatsApp",
    "whatsapp.message": "Hello, I'm interested in one of your vehicles.",
    "viber.label": "Viber",
  },

  gr: {
    // Navigation
    "nav.home": "Αρχική",
    "nav.garage": "Διαθέσιμα",
    "nav.request": "Αίτημα Αυτοκινήτου",
    "nav.contact": "Επικοινωνία",
    "nav.cta": "Αίτημα Αυτοκινήτου",
    "nav.language.en": "EN",
    "nav.language.gr": "GR",

    // Hero
    "hero.headline": "Το αυτοκίνητο που αναζητάτε. Χωρίς συμβιβασμούς.",
    "hero.subheadline":
      "Αναλαμβάνουμε την εύρεση και παράδοση επιλεγμένων οχημάτων, απόλυτα προσαρμοσμένων στις απαιτήσεις σας.",
    "hero.tagline": "Ιδιωτική Επιλογή · Κατόπιν Ραντεβού",
    "hero.cta.primary": "Δείτε τα διαθέσιμα",
    "hero.cta.secondary": "Αίτημα Αυτοκινήτου",

    // The House
    "house.label": "Ο Οίκος",
    "house.title.part1": "Ένας ιδιωτικός οίκος για",
    "house.title.accent": "επιλεγμένα οχήματα",
    "house.p1":
      "Η Elysian Cars αποτελεί boutique αντιπροσωπεία της THS Estate Development Group Ε.Ε. — μια προσεκτικά επιλεγμένη συλλογή οχημάτων για μια απαιτητική πελατεία.",
    "house.p2":
      "Δεν λειτουργούμε ως marketplace. Κάθε όχημα είναι προϊόν ιδιωτικής αναζήτησης και επιμελούς επιλογής.",
    "house.p3": "Αποκλειστικά κατόπιν ραντεβού.",

    // A Different Approach
    "approach.label": "Η Προσέγγισή μας",
    "approach.title.part1": "Το σωστό όχημα.",
    "approach.title.accent": "Χωρίς συμβιβασμούς.",
    "approach.body":
      "Επιλέγουμε με αυστηρά κριτήρια και παρουσιάζουμε μόνο ό,τι πληροί τα πρότυπά μας.",
    "approach.stat.sourced": "Αναζήτηση",
    "approach.stat.sourced.v": "Παγκοσμίως",
    "approach.stat.process": "Διαδικασία",
    "approach.stat.process.v": "Ιδιωτική",
    "approach.stat.selection": "Επιλογή",
    "approach.stat.selection.v": "Επιμελημένη",
    "approach.stat.delivery": "Παράδοση",
    "approach.stat.delivery.v": "Κατόπιν Ραντεβού",

    // Featured
    "featured.label": "Προτεινόμενα",
    "featured.title": "Στη Συλλογή μας",
    "featured.viewAll": "Όλα τα οχήματα",

    // CTA block
    "cta.label": "Εξατομικευμένο Αίτημα",
    "cta.title.part1": "Δεν το βρίσκετε;",
    "cta.title.accent": "Το εντοπίζουμε για εσάς.",
    "cta.body":
      "Πείτε μας τις προτιμήσεις σας — μοντέλο, χρώμα, προδιαγραφές. Αναλαμβάνουμε την αναζήτηση.",
    "cta.button": "Αίτημα Αυτοκινήτου",

    // Garage
    "garage.label": "Η Συλλογή",
    "garage.title": "Επιλεγμένα οχήματα",
    "garage.subtitle":
      "Επιλεγμένα οχήματα, ελεγμένα και έτοιμα για ιδιωτικό ραντεβού.",
    "garage.filter.all": "Όλα",
    "garage.filter.available": "Διαθέσιμα",
    "garage.filter.reserved": "Δεσμευμένα",
    "garage.filter.sold": "Πωλήθηκαν",
    "garage.empty.title": "Δεν υπάρχουν διαθέσιμα οχήματα αυτήν τη στιγμή.",
    "garage.empty.subtitle": "Επιστρέψτε σύντομα ή περιγράψτε τι αναζητάτε.",

    // Vehicle card / detail
    "vehicle.status.available": "Διαθέσιμο",
    "vehicle.status.reserved": "Δεσμευμένο",
    "vehicle.status.sold": "Πωλήθηκε",
    "vehicle.spec.year": "Έτος",
    "vehicle.spec.km": "Χλμ",
    "vehicle.spec.mileage": "Χιλιόμετρα",
    "vehicle.spec.fuel": "Καύσιμο",
    "vehicle.spec.transmission": "Κιβώτιο",
    "vehicle.spec.transmission.short": "Κιβ.",
    "vehicle.price": "Τιμή",
    "vehicle.back": "Επιστροφή στη Συλλογή",
    "vehicle.notFound": "Το όχημα δεν βρέθηκε",
    "vehicle.loading": "Φόρτωση…",
    "vehicle.enquire": "Αίτημα Πληροφοριών",
    "vehicle.bookAppointment": "Κλείστε Ραντεβού",

    // Request form
    "request.label": "Αίτημα Αυτοκινήτου",
    "request.title.part1": "Περιγράψτε τι",
    "request.title.accent": "αναζητάτε",
    "request.intro":
      "Επιλέγουμε οχήματα βάσει των δικών σας προδιαγραφών και προτύπων.",
    "request.note": "Επιλεγμένα οχήματα. Εξυπηρέτηση κατόπιν ραντεβού.",
    "request.channels.whatsapp": "WhatsApp",
    "request.channels.viber": "Viber",
    "request.channels.phone": "Τηλέφωνο",
    "request.channels.email": "Email",
    "request.contact.phone": "Τηλέφωνο",
    "request.contact.email": "Email",
    "request.form.name": "Ονοματεπώνυμο",
    "request.form.name.placeholder": "Το ονοματεπώνυμό σας",
    "request.form.phone": "Τηλέφωνο",
    "request.form.phone.placeholder": "+30 ...",
    "request.form.email": "Email",
    "request.form.email.placeholder": "you@example.com",
    "request.form.preference": "Τι αναζητάτε",
    "request.form.preference.placeholder":
      "Μοντέλο, προδιαγραφές, έτος, χρώμα, εξοπλισμός…",
    "request.form.budget": "Προϋπολογισμός",
    "request.form.budget.placeholder": "€ εύρος",
    "request.form.message": "Μήνυμα",
    "request.form.message.placeholder":
      "Προδιαγραφές, χρονοδιάγραμμα ή επιπλέον πληροφορίες…",
    "request.form.submit": "Αποστολή",
    "request.form.submitting": "Αποστολή…",
    "request.success.title": "Λάβαμε το αίτημά σας",
    "request.success.subtitle":
      "Η ομάδα μας θα επικοινωνήσει μαζί σας σύντομα.",
    "request.success.again": "Νέο αίτημα",
    "request.toast.success":
      "Λάβαμε το αίτημά σας. Θα επικοινωνήσουμε σύντομα.",
    "request.toast.error": "Κάτι πήγε στραβά",

    // Contact
    "contact.label": "Επικοινωνία",
    "contact.title.part1": "Επικοινωνήστε",
    "contact.title.accent": "μαζί μας",
    "contact.intro": "Εξυπηρέτηση αποκλειστικά κατόπιν ραντεβού.",
    "contact.cell.phone": "Τηλέφωνο",
    "contact.cell.email": "Email",
    "contact.cell.whatsapp": "WhatsApp",
    "contact.cell.whatsapp.v": "Επικοινωνία μαζί μας",
    "contact.cell.viber": "Viber",
    "contact.cell.viber.v": "Άνοιγμα στο Viber",
    "contact.cell.hours": "Ώρες",
    "contact.cell.hours.v": "Κατόπιν Ραντεβού",
    "contact.side.label": "Αναζητάτε συγκεκριμένο όχημα;",
    "contact.side.title": "Περιγράψτε τι αναζητάτε.",
    "contact.side.body":
      "Περιγράψτε τι αναζητάτε και θα επιστρέψουμε με επιλογές.",
    "contact.side.cta": "Αίτημα Αυτοκινήτου",

    // Footer
    "footer.company": "THS Estate Development Group Ε.Ε.",
    "footer.rights": "— Με επιφύλαξη παντός δικαιώματος",
    "footer.signature": "Ιδιωτική επιλογή • Κατόπιν ραντεβού",

    // WhatsApp / Viber
    "whatsapp.label": "WhatsApp",
    "whatsapp.message":
      "Καλησπέρα, θα ήθελα περισσότερες πληροφορίες για ένα από τα οχήματά σας.",
    "viber.label": "Viber",
  },
};

export default translations;
